import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';

@Component({
  selector: 'app-um-map-org-auth-view-modal',
  standalone: false,
  templateUrl: './um-map-org-auth-view-modal.component.html',
  styleUrl: './um-map-org-auth-view-modal.component.scss'
})
export class UmMapOrgAuthViewModalComponent implements OnInit{

  @Input() public Content: any;
  searchFilter: string="";
  selectedCount:number=0;

  auths: any[];
  Auth:Authentication = <Authentication>{};

  constructor(    
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private summaryService: AdministrationSummaryService,
  ){
  }

  ngOnInit(): void {
    this.getAuthentications();
  }

  getAuthentications(){
    this.Auth.Status = "1";
    this.summaryService.PostData('api/Configuration/GetAuthSearchSummary', this.Auth).subscribe(summary => {
      let auths= summary;
     
      this.auths=[];
      auths.forEach(element => {
        if(this.Content.content.selectedIds.indexOf(element.ID)==-1)
        {
            element["IsMarked"]=false;
            this.auths.push(element);
        }
      });
  });
  }
  
  CancelPopup() { 
    this.modalRef.dismiss();
  }

  SaveAuths(){ 
    let selectedIds = [];
    if (this.auths.length > 0) {
      selectedIds = this.auths.filter(function (a) {
        return (a["IsMarked"] == true)
      });
    }
      this.modalRef.close(selectedIds);
  }

  collectAuths(authId) {
    this.selectedCount=0;
    this.auths.forEach((item: any) => {
      if (item.ID == authId) {
        if (item.IsMarked)
          item.IsMarked = false;
        else
          item.IsMarked = true;
      }
      if(item.IsMarked==true)
      {
        this.selectedCount=this.selectedCount+1;
      }
    });
  }

}

export interface Authentication {
  AuthName: string;
  AuthType: string;
  IsMarked: boolean;
  Status: string;
}
